'use strict';
const angular = require('angular');

export class TemplateLookupComponent {
  /*@ngInject*/
  constructor(TemplateService) {
    this.TemplateService = TemplateService;

    this.data = [];

    this.TemplateService.query((data) => {
      this.data = data;
      this.dataInitComplete = true;
    }, err => {
      console.log("Could not retrieve templates.")
    });
  }

  $onInit = function () {
    this.config = this.resolve.config;
  };

  ok(template) {
    this.close({$value: template});
  }

  cancel() {
    this.dismiss({$value: 'cancel'});
  }
}

export default angular.module('conduu.templateLookup', [])
  .component('templateLookup', {
    template: require('./template-lookup.component.html'),
    bindings: {
      resolve: '<',
      config: '<',
      close: '&',
      dismiss: '&'
    },
    controller: TemplateLookupComponent
  })
  .name;



// WEBPACK FOOTER //
// ./client/components/template-lookup/template-lookup.component.js